import { Type } from 'class-transformer';
import { RegionEntity } from './RegionEntity';
import { SiteEntity } from './SiteEntity';
import { FeatureEntity } from '../../services/FeatureService';
import { AccountEntity } from './AccountEntity';
import { UserEntity } from './UserEntity';

export class OrganizationEntity {
    id: string;

    name: string;

    @Type(() => RegionEntity)
    regions: RegionEntity[] = [];

    accounts?: AccountEntity[];

    practicesAmount?: number;

    features?: FeatureEntity[];

    organization_id: string | null = null;

    @Type(() => SiteEntity)
    all_sites: SiteEntity[] = [];

    @Type(() => UserEntity)
    owner: UserEntity;
}
